export const Modal = ({ size = 'small', isOpen = false, children, className = '' }) => {
  if (!isOpen) return null

  return (
    <div {...(className ? { className: className } : {})}>
      <div className='control-modal-overlay' />
      <section role='dialog' className={`control-modal control-modal-${size}`}>
        {children}
      </section>
    </div>
  )
}
